import { Input } from 'antd'
import { createStyles } from 'antd-style'

import { PasswordProps } from './interface'
import { PasswordStrength } from './PasswordStrength'

const useStyles = createStyles(({ token }) => ({
  password: {
    width: '100%'
  },
  indicator: {
    background: '#e0e0e0',
    marginBottom: 3,
    position: 'relative'
  },
  dot: {
    position: 'absolute',
    zIndex: 1,
    height: 8,
    top: 0,
    background: '#fff',
    width: 1,
    transform: 'translate(-50%, 0)'
  },
  line: {
    position: 'relative',
    background: `linear-gradient(to right, #ff9300 , #ff5500)`,
    transition: 'all 0.35s ease-in-out',
    height: 8,
    width: '100%',
    marginTop: 5
  }
}))

export const Password = ({
  className,
  style,
  value,
  checkStrength,
  allowClear = true,
  ...others
}: PasswordProps) => {
  const { cx, styles } = useStyles()

  return (
    <span className={cx(styles.password, className)} style={style}>
      <Input.Password
        {...others}
        allowClear={allowClear}
        autoComplete='off'
        value={value}
      />
      {checkStrength && (
        <PasswordStrength value={String(value)}>
          {score => {
            return (
              <div className={styles.indicator}>
                <div className={styles.dot} style={{ left: '20%' }} />
                <div className={styles.dot} style={{ left: '40%' }} />
                <div className={styles.dot} style={{ left: '60%' }} />
                <div className={styles.dot} style={{ left: '80%' }} />
                <div
                  className={styles.line}
                  style={{
                    clipPath: `polygon(0 0,${score}% 0,${score}% 100%,0 100%)`
                  }}
                />
              </div>
            )
          }}
        </PasswordStrength>
      )}
    </span>
  )
}
